import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function FarmingtonHillsScheduleLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1239">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1240">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-1241">
          <div data-id="element-1242">
            <h2 className="text-4xl text-ink mb-8" data-id="element-1243">Class Times</h2>
            <ScheduleTable data-id="element-1244" />
          </div>
          <div data-id="element-1245">
            <h2 className="text-4xl text-ink mb-8" data-id="element-1246">Location Details</h2>
            <LocationBlock data-id="element-1247" />
          </div>
        </div>
      </div>
    </section>;
}